import ProductAdvancedForm from './ProductAdvancedForm'

export default ProductAdvancedForm
